import config from 'config/appConfig';

/**
 * ボイスチャットのプレビューURLを取得します。
 */
export function getPreviewUrl(voiceChatPreviewCd: string): string {
  return `${config.url.userWeb}/voice_chat/preview/${voiceChatPreviewCd}`;
}

/**
 * ボイスチャットのプレビューURLを開きます。
 */
export function openPreviewUrl(voiceChatPreviewCd: string): void {
  window.open(getPreviewUrl(voiceChatPreviewCd), '_blank');
}

/**
 * ボイスチャットの公開URLを取得します。
 */
export function getProductionUrl(voiceChatCd: string): string {
  return `${config.url.userWeb}/voice_chat/${voiceChatCd}`;
}

/**
 * ボイスチャットの公開URLを開きます。
 */
export function openProductionUrl(voiceChatCd: string): void {
  window.open(getProductionUrl(voiceChatCd), '_blank');
}
